import { render, staticRenderFns } from "./PraisedContent.vue?vue&type=template&id=6418d8c0&scoped=true&"
import script from "./PraisedContent.vue?vue&type=script&lang=js&"
export * from "./PraisedContent.vue?vue&type=script&lang=js&"
import style0 from "./PraisedContent.vue?vue&type=style&index=0&id=6418d8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418d8c0",
  null
  
)

component.options.__file = "PraisedContent.vue"
export default component.exports